import cx from 'classnames';

const SubmissionFormCopySettings = ({ formData, handelInitSettings, initData, errors }) => {
  return (
    <>
      <div className="form-control-item-settings">
        <div className="form-settings-label">
          <label className="form-label form-label-big">Send a copy of the form to the initiator (email)?</label>
          <span>Define whether a copy of the form should be automatically sent to the initiator by email</span>
        </div>
        <div className="form-settings-inputs">
          <div className="d-flex">
            <div className={`form-control-radio`}>
              <input
                name="send_copy_to_initiator"
                type="radio"
                checked={initData.send_copy_to_initiator === true}
                onChange={() => handelInitSettings(true, 'send_copy_to_initiator')}
              />
              <span>Yes</span>
            </div>
            <div className={`form-control-radio`}>
              <input
                name="send_copy_to_initiator"
                type="radio"
                checked={initData.send_copy_to_initiator !== true}
                onChange={() => handelInitSettings(false, 'send_copy_to_initiator')}
              />
              <span>No</span>
            </div>
          </div>
          <span className="form-error mb-2">{errors?.send_copy_to_initiator && errors.send_copy_to_initiator[0]}</span>
        </div>
      </div>
      <div className="form-control-item-settings">
        <div className="form-settings-label">
          <label className="form-label form-label-big">Send the completed form as a PDF to the submitter (email)?</label>
          <span>Define whether the completed form should be automatically generated as a PDF and sent to the submitter by email</span>
        </div>
        <div className="form-settings-inputs">
          <div className="d-flex">
            <div className={`form-control-radio`}>
              <input
                name="send_completed_form_to_submitter"
                type="radio"
                checked={initData.send_completed_form_to_submitter === true}
                onChange={() => handelInitSettings(true, 'send_completed_form_to_submitter')}
              />
              <span>Yes</span>
            </div>
            <div className={`form-control-radio`}>
              <input
                name="send_completed_form_to_submitter"
                type="radio"
                checked={initData.send_completed_form_to_submitter !== true}
                onChange={() => handelInitSettings(false, 'send_completed_form_to_submitter')}
              />
              <span>No</span>
            </div>
          </div>
          <span className="form-error mb-2">{errors?.send_completed_form_to_submitter && errors.send_completed_form_to_submitter[0]}</span>
        </div>
      </div>
    </>
  );
};

export default SubmissionFormCopySettings;
